import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AddonFormView } from "../features/menu/addon-form";
import { BackToMenu } from "../features/menu/back-link";
import { useInPanes } from "../features/menu/panes";
import { Require } from "../features/require";

export const Route = createFileRoute("/menu/addons/$groupId")({ component: Page });

function Page() {
	const { groupId } = Route.useParams();
	const navigate = useNavigate();
	const inPanes = useInPanes();
	return (
		<Require permission="menu.edit">
			<div className="max-w-3xl">
				<AddonFormView
					key={groupId}
					groupId={groupId}
					back={<BackToMenu to="/menu/addons" />}
					onSaved={() => {
						if (!inPanes) void navigate({ to: "/menu/addons" });
					}}
					onDeleted={() => void navigate({ to: "/menu/addons" })}
				/>
			</div>
		</Require>
	);
}
